import React, { useState } from 'react'
import cl from 'classnames'

import Icon from 'Shared/atoms/Icon'

import styles from './styles.module.scss'

type Props = {
	defaultValue?: boolean
	iconClassName?: string
	onClickCallback?: (isActive: boolean) => void
	wrapperClassName?: string
	isClickable?: boolean
}

const StarCheckbox: React.FC<Props> = ({
	isClickable,
	defaultValue,
	iconClassName,
	onClickCallback,
	wrapperClassName
}) => {
	const [isActive, setIsActive] = useState(defaultValue)

	const handleClick = (event: React.MouseEvent) => {
		event.stopPropagation()

		setIsActive(!isActive)
		onClickCallback?.(!isActive)
	}

	return (
		<Icon
			type={isActive ? 'starActive' : 'starDefault'}
			onClick={isClickable ? handleClick : void 0}
			className={cl(styles.wrapper, wrapperClassName, iconClassName, {
				[styles.nonClickable]: !isClickable
			})}
		/>
	)
}

export default React.memo(StarCheckbox)
